<template>
  <div id="content-wrap" style="padding-top: 50px;">
    <div class="container">
      <div class="row" v-show="!isUsbOnly">
        <div class="col-lg-6 col-md-6 col-sm-12 wow fadeInLeft" data-wow-delay="0.6s">
          <h4><strong>Network Printers Client Installer</strong></h4>
          <p>Download "Network Client Installer" for monitoring Network printers</p>
          <p>Collect NETWORK printer counters automatically & schedule reports</p>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 wow fadeIn" data-wow-delay="0.9s">
          <div class="box box-widget widget-user-2">
            <downloadBtn style="width: 300px; text-align: center;"
                         :title="btnLAN.title"
                         :img="btnLAN.img"
                         :info="btnLAN.info"
                         :icon="btnLAN.icon"
                         :btnText="btnLAN.btnText"
                         @click="downloadClient()">
            </downloadBtn>
          </div>
          </div>
        </div>
      <div class="row" v-show="!isNetworkOnly">
        <div class="col-lg-6 col-md-6 col-sm-12 wow fadeInLeft" data-wow-delay="0.6s">
          <h4><strong>USB Printers Client Installer</strong></h4>
          <p>Download "USB Client Installer" for monitoring USB printers</p>
          <p>Collect USB printer counters automatically & schedule reports</p>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 wow fadeIn" data-wow-delay="0.9s">
          <downloadBtn style="width: 300px;"
                       :title="btnUSB.title"
                       :img="btnUSB.img"
                       :info="btnUSB.info"
                       :icon="btnUSB.icon"
                       :btnText="btnUSB.btnText"
                       @click="downloadClientUSB()">
          </downloadBtn>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  // import footerBox from '../components/Home/footer'
  import downloadBtn from './downloadBtn'
  import { db } from '../../firebase'
  export default {
    name: 'downloads',
    components: { downloadBtn },
    data () {
      return {
        isNetworkOnly: false,
        isUsbOnly: false,
        btnLAN: {
          title: 'Network Printers',
          img: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAI4AAACOCAYAAADn/TAIAAAACXBIWXMAABcRAAAXEQHKJvM/AAACeUlEQVR4Xu3dsW1bZxiG0U+B9nDGCCsxk0SV1ogyRljJk/iqYusRlA2ygVLIZcCfeGhHtHNO/QIkLh+SAIH78+b19XW+V7vDts3M3Wp3pX49Puy31eha/bQawL8RDolwSIRDIhwS4ZAIh0Q4JMIhEQ6JcEiEQyIcEuGQCIdEOCTCIREOiXBIhEMiHBLhkAiHRDgkN9/zDXlf0+6wnXMh/jg+7B9Xo/8DnzgkwiERDolwSIRDIhwS4ZAIh0Q4JMIhEQ6JcEiEQyIcEuGQCIdEOCTCIREOiXBIhEMiHBLhkAiHRDgkwiERDolwSIRDIhwS4ZAIh0Q4JMIhEQ6JcEiEQyIcEuGQCIfkogOyd4dtPzOfVjuuzvPxYb9fjU7xiUMiHBLhkAiHRDgkwiERDolwSG5Xg6/k48y8rEbv7PfVYGaeZ2Zbjd7Z/cx8WI0u9V+F83R82G+r0XvaHbZzwtmu/a8Vv/ya/83D8VVFIhwS4ZAIh0Q4JMIhEQ6JcEiEQyIcEuGQCIdEOCTCIREOiXBIhEMiHBLhkAiHRDgkwiERDolwSIRDIhwS4ZAIh0Q4JMIhEQ6JcEiEQyIcEuGQCIdEOCTCIREOyc0vf356XI1O+HlmfluN5sIDss85W3h32O7n7flU55xzfOkB2U/Hh/3LqcGXc4r3pzYL97M+5/ivmXlabE55uZ3zLtilzonrlMfVYN4u2N1qdKG7uewxtlm/gfbz7V+TD3PZYzz7qiIRDolwSIRDIhwS4ZAIh0Q4JMIhEQ6JcEiEQyIcEuGQCIdEOCTCIREOiXBIhEMiHBLhkAiH5HbebjL7EXxeDa7A36vBvN13de2vyed/AIymQ7HCJiFzAAAAAElFTkSuQmCC',
          info: 'Collect NETWORK printer counters automatically & schedule reports',
          icon: 'fa fa-download',
          btnText: 'Download Network Client Installer'
        },
        btnUSB: {
          title: 'USB Printers',
          img: 'data:image/png;base64,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',
          info: 'Collect USB printer counters automatically & schedule reports',
          icon: 'fa fa-download',
          btnText: 'Download USB Client Installer'
        }
      }
    },
    created () {
      this.isNetworkOnly = false
      this.isUsbOnly = false
      if (this.$route.params.type === 'Network') {
        this.isNetworkOnly = true
      }
      if (this.$route.params.type === 'USB') {
        this.isUsbOnly = true
      }
    },
    computed: {
    },
    methods: {
      downloadClient () {
        let vm = this
        console.log('downloadClient started...')
        db.ref('Settings/ClientInstaller').once('value', (snapInstaller) => {
          const installer = snapInstaller.val()
          if (installer) {
            var hiddenElement = document.createElement('a')
            hiddenElement.href = installer.DownloadUrl
            // hiddenElement.target = '_blank'
            hiddenElement.download = installer.Name
            hiddenElement.click()
            vm.$root.goto('Greeting')
          }
        })
      },
      downloadClientUSB () {
        let vm = this
        console.log('downloadClientUSB started...')
        db.ref('Settings/ClientInstallerUSB').once('value', (snapInstaller) => {
          const installer = snapInstaller.val()
          if (installer) {
            var hiddenElement = document.createElement('a')
            hiddenElement.href = installer.DownloadUrl
            // hiddenElement.target = '_blank'
            hiddenElement.download = installer.Name
            hiddenElement.click()
            vm.$root.goto('Greeting')
          }
        })
      },
      goHome () {
        console.log('goHome')
        this.$root.goto('Home')
        location.reload(true)
      },
      testFunction () {
        // Call axios
        let vm = this
        let emailData = {
          SendTo: 'abedali1977@gmail.com',
          Subject: 'Thank you for choosing Printer Counters',
          Template: 'test.html',
          TemplateData: {
            FirstName: 'Abed ElSalam',
            LastName: 'Ali',
            Date: '01/07/2020 17:00'
          }
        }
        emailData = {
          SendTo: 'abedali1977@gmail.com',
          Subject: 'HELLO  --- Thank you for choosing Printer Counters',
          Template: 'welcome.html',
          TemplateData: {
            FirstName: 'Abed ElSalam',
            LastName: 'Ali',
            Date: '02/07/2020 17:00'
          }
        }
        let query = '?Data=' + JSON.stringify(emailData)
        // console.log(query)
        // let urlWithQuery = 'https://us-central1-b-info.cloudfunctions.net/SendAlert' + query
        let urlWithQuery = 'http://localhost:5001/b-info/us-central1/SendEmail' + query
        var request = { url: urlWithQuery, method: 'get', responseType: 'json' }
        vm.$axios(request).then(function (response) {
          // callback(response.data)
          console.log(response)
        })
        .catch(function (error) {
          // callback({ Success: false, Data: error })
          console.log(error)
        })
      }
    }
  }
</script>
<style scoped>
  
</style>



// WEBPACK FOOTER //
// download.vue?5ee96724